import mapSliceTypeToComponent from '~/imports/designer_page'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import { SliceManager } from '@unlikelystudio/react-abstract-components'

import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import PageWithFilters from '~/components/PageWithFilters'
import HeroFilteredPage from '~/components/UI/HeroFilteredPage'

import getMetalStonePageStaticPropsFunction from '~/data/metal-stone-page-data'
import { MetalStonePageData } from '~/data/metal-stone-page-data/serializer'
import { getPaginatedStaticPathsFunction } from '~/data/page-data'

function DesignerPage({ slices, heroData, ...props }: MetalStonePageData) {
  return (
    <>
      <HeroFilteredPage {...heroData} />
      <PageWithFilters customLayout {...props}>
        <SliceManager
          mapSliceTypeToComponent={mapSliceTypeToComponent}
          slicesData={slices}
        />
      </PageWithFilters>
      <PageViewAnalytics template="collection" />
    </>
  )
}

export default DesignerPage

export const getStaticProps = getMetalStonePageStaticPropsFunction()
export const getStaticPaths = getPaginatedStaticPathsFunction({
  withPage: false,
  type: STORYBLOK_TYPES.METAL_STONE_PAGE,
  maxPathsInProduction: 10,
})
